export default {
    state: {
        role: 0
    },
    actions: {
        setRole({state}, data) {

            state.role = data;
        }
    }
};





// WEBPACK FOOTER //
// ./src/store/login.js